 import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function RulesPage() {
  const navigate = useNavigate();
  const [agreed, setAgreed] = useState(false);

  return (
    <div style={styles.page}>
      {/* Embedded CSS – now responsive for mobile */}
      <style>
        {`
          * {
            box-sizing: border-box;
          }
          html, body, #root {
            margin: 0;
            padding: 0;
            height: 100%;
            overflow: hidden;
          }
          .rules-page-wrapper {
            height: 100dvh;
            width: 100vw;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          /* Header – vertical stacking by default */
          .responsive-header {
            display: flex;
            flex-direction: column;
            width: 100%;
            align-items: center;
            margin-bottom: 24px;
            flex-shrink: 0;
          }

          .responsive-buttons {
            display: flex;
            flex-direction: row;
            gap: 16px;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            margin-top: 8px;
            width: 100%;
          }

          .action-btn {
            width: 220px;
            height: 48px !important;
            display: flex;
            justify-content: center;
            align-items: center;
            box-sizing: border-box;
            flex-shrink: 0;
          }

          /* === Mobile adjustments === */
          @media (max-width: 768px) {
            .card {
              padding: 16px 16px 20px !important;
            }

            .main-title {
              font-size: 28px !important;
            }
            .main-title span:first-child {
              font-size: 24px !important;
            }
            .main-title span:last-child {
              font-size: 20px !important;
            }

            .sub-title {
              font-size: 20px !important;
            }
            .quiz-title {
              font-size: 24px !important;
            }
            .desc-text {
              font-size: 16px !important;
            }
            .date-badge {
              font-size: 16px !important;
              padding: 6px 12px !important;
            }

            .section-heading {
              font-size: 18px !important;
            }
            .rule-point {
              font-size: 14px !important;
            }

            .nstad-box {
              font-size: 16px !important;
              padding: 14px 18px !important;
            }
            .nstad-box-link {
              font-size: 18px !important;
            }

            .checkbox-label {
              font-size: 15px !important;
            }

            .action-btn {
              width: 100% !important;
              max-width: 280px !important;
            }
            .responsive-buttons {
              flex-direction: column;
              gap: 10px;
            }
          }

          @media (max-width: 480px) {
            .card {
              padding: 12px 12px 16px !important;
            }

            .main-title {
              font-size: 22px !important;
            }
            .main-title span:first-child {
              font-size: 20px !important;
            }
            .main-title span:last-child {
              font-size: 17px !important;
            }

            .sub-title {
              font-size: 17px !important;
            }
            .quiz-title {
              font-size: 20px !important;
            }
            .desc-text {
              font-size: 14px !important;
            }
            .date-badge {
              font-size: 14px !important;
            }

            .section-heading {
              font-size: 16px !important;
            }
            .rule-point {
              font-size: 13px !important;
            }

            .nstad-box {
              font-size: 14px !important;
              padding: 12px 14px !important;
            }
            .nstad-box-link {
              font-size: 15px !important;
            }

            .checkbox-label {
              font-size: 13px !important;
            }
          }
        `}
      </style>

      <div className="rules-page-wrapper">
        <div style={styles.bgCircle1} />
        <div style={styles.bgCircle2} />

        <div style={{ ...styles.card, className: "card" }}>
          
          {/* Header – full width, no box */}
          <div className="responsive-header">
            <h1 style={styles.mainTitle} className="main-title">
              <span style={{ fontSize: "40px", fontWeight: "800", color: "#1d5290" }}>
                राष्ट्रीय बिज्ञान और प्रौद्योगिकी डिजिटल अभिलेखागार
              </span>
              <br />
              <span style={{ fontSize: "32px", fontWeight: "700", color: "#2d2d44" }}>
                National Science &amp; Technology Digital Archive
              </span>
            </h1>
            
            <p style={styles.subTitle} className="sub-title">
              Invites students and researchers to participate in a
            </p>

            <p style={{ color:"black", fontSize: "32px", fontWeight: "900", margin: "0 0 12px 0" }} className="quiz-title">
              ONLINE QUIZ
            </p>

            <p style={styles.descText} className="desc-text">
              Celebrating the life, works, and scientific legacy of <strong>Acharya Prafulla Chandra Ray</strong>, one of the greatest chemists and a pioneer of modern scientific research in India.
            </p>

            <div style={styles.dateBadge} className="date-badge">
              <strong>Quiz Date:</strong> 30.08.2026 &nbsp;|&nbsp; <strong>Time:</strong> 11:30 Hrs
            </div>
          </div>

          {/* Rules – sections with headings and numbered points */}
          <div style={styles.rulesTextBlock}>
            
            {/* Eligibility Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionHeading} className="section-heading">Eligibility</h3>
              <p style={styles.rulePoint} className="rule-point">1. The quiz is open to students of Class X, XI, XII, undergraduate, postgraduate, and ongoing Ph.D. students (from any stream) enrolled in any recognized school, college, university, or academic institution within India.</p>
              <p style={styles.rulePoint} className="rule-point">2. Participation is free of cost and open to entrants from across India (Pan-India).</p>
              <p style={styles.rulePoint} className="rule-point">3. Each participant is permitted to submit only one entry. Multiple submissions by the same participant may lead to disqualification.</p>
            </div>

            {/* Quiz Format Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionHeading} className="section-heading">Quiz Format</h3>
              <p style={styles.rulePoint} className="rule-point">1. The quiz will be conducted in <strong>English</strong> only.</p>
              <p style={styles.rulePoint} className="rule-point">2. The quiz will be conducted using application software designed to run on desktop, laptop, or mobile devices with Windows or Android operating systems. The software is <strong>not</strong> compatible with Mac OS/iOS.</p>
              <p style={styles.rulePoint} className="rule-point">3. The quiz consists of multiple-choice questions.</p>
              <p style={styles.rulePoint} className="rule-point">4. Quiz is primarily based on archival documents available at National Science and Technology Digital Archive (NSTAD) related to Acharya Prafulla Chandra Ray.</p>
              <p style={styles.rulePoint} className="rule-point">5. Participants are encouraged to explore the archival materials available on the portal (<a href="https://nstad.in" target="_blank" rel="noopener noreferrer" style={styles.nstadLink}>https://nstad.in</a>) before attempting the quiz. A separate registration process is required to access the portal <a href="https://nstad.in" target="_blank" rel="noopener noreferrer" style={styles.nstadLink}>https://nstad.in</a>. Detailed instructions for registering and logging in to the portal are also available on the portal.</p>
              <p style={styles.rulePoint} className="rule-point">6. The quiz consists of <strong>25 questions</strong>, presented one by one. For each question, participants can select the answer they believe is correct and use the "Next" or "Previous" button to move to the next or previous question.</p>
              <p style={styles.rulePoint} className="rule-point">7. Prior registration is required for participation in the Quiz. Participants are advised to register well in advance of the scheduled date and time.</p>
              <p style={styles.rulePoint} className="rule-point">8. Immediately after registration, participants will receive a registration document in PDF format. The <strong>registration number</strong> will serve as the <strong>login ID</strong> for the quiz, and the <strong>email ID</strong> provided during registration will be used as the password.</p>
              <p style={styles.rulePoint} className="rule-point">9. The portal will not allow entry or participation outside the scheduled time. The quiz will be available for participation on <strong>August 30, 2026, at 11:30 hrs. sharp.</strong> Participants are requested to log in to the portal <strong>5 minutes</strong> before the quiz starts.</p>
              <p style={styles.rulePoint} className="rule-point">10. The duration of the quiz is <strong>15 minutes</strong>.</p>
              <p style={styles.rulePoint} className="rule-point">11. Immediately after the quiz starts, a message requesting full-screen mode will be displayed, and the participant must agree to expand the screen to full size.</p>
              <p style={styles.rulePoint} className="rule-point">12. Participants may change their answers within the scheduled time. A specific question can be revisited using the question palette at the top-right corner of the screen, which also allows participants to identify unanswered questions and change their answers as needed.</p>
            </div>

            {/* Submission Guidelines Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionHeading} className="section-heading">Submission Guidelines</h3>
              <p style={styles.rulePoint} className="rule-point">1. Participants can view the remaining time on the Timer and must submit their chosen answers when finished by clicking the <strong>"SUBMIT"</strong> button before the end of the scheduled time, after which the screen will disappear immediately.</p>
              <p style={styles.rulePoint} className="rule-point">2. Participants who fail to submit their final answers within the stipulated time will be treated as <strong>disqualified</strong>, and their response will not be evaluated.</p>
              <p style={styles.rulePoint} className="rule-point">3. Once submitted, answers cannot be edited or resubmitted.</p>
            </div>

            {/* Evaluation Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionHeading} className="section-heading">Evaluation</h3>
              <p style={styles.rulePoint} className="rule-point">1. Each correct answer carries <strong>two (2) marks</strong>. <strong>One (1) mark</strong> will be deducted for each wrong answer.</p>
              <p style={styles.rulePoint} className="rule-point">2. In the event of a tie, the participant who submitted his/her entry the fastest will be considered the winner.</p>
              <p style={styles.rulePoint} className="rule-point">3. If required, the organizing committee may apply additional tie-breaker criteria.</p>
              <p style={styles.rulePoint} className="rule-point">4. Winners will be selected based on the highest score, with the fastest response time as a determining factor in accordance with the quiz rules.</p>
            </div>

            {/* Disclaimer & Terms of Participation Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionHeading} className="section-heading">Disclaimer &amp; Terms of Participation</h3>
              <p style={styles.rulePoint} className="rule-point">By clicking "I have read and agreed to," you acknowledge that you have read, understood, and accepted the rules and regulations governing this quiz. Participation in the quiz shall constitute a legally binding agreement to abide by and comply with all terms and conditions set forth herein.</p>
              <p style={styles.rulePoint} className="rule-point">The organizers shall not be held liable or responsible for any loss, damage, or inconvenience arising from software malfunction, technical error, or any other issue.</p>
              <p style={styles.rulePoint} className="rule-point">The organizer reserves the right, at its sole and absolute discretion, to modify, amend, postpone, suspend, or cancel the quiz, in whole or in part, at any time, without prior notice and without incurring any liability whatsoever to participants.</p>
            </div>

          </div>

          {/* NSTAD Box */}
          <div style={styles.nstadBox} className="nstad-box">
            <span style={styles.pinEmoji}>📌</span>{" "}
            <span style={styles.nstadBoxText}>
              Explore the National Science and Technology Digital Archive:{" "}
              <a href="https://www.nstad.in" target="_blank" rel="noopener noreferrer" style={styles.nstadBoxLink} className="nstad-box-link">
                www.nstad.in
              </a>
            </span>
          </div>

          {/* Checkbox & Action Buttons */}
          <div style={styles.actionGroup}>
            <label style={styles.checkboxLabel} className="checkbox-label">
              <input
                type="checkbox"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
                style={styles.checkbox}
              />
              I have read, understood, and agree to be bound by the above Terms and Conditions.
            </label>
            <div className="responsive-buttons">
              <button
                className="action-btn"
                style={{
                  ...styles.primaryBtn,
                  opacity: agreed ? 1 : 0.5,
                  cursor: agreed ? "pointer" : "not-allowed",
                }}
                onClick={() => agreed && navigate("/register")}
                disabled={!agreed}
                onMouseEnter={(e) => {
                  if (agreed) {
                    e.target.style.transform = "translateY(-3px)";
                    e.target.style.boxShadow = "0 8px 25px rgba(108, 92, 231, 0.4)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (agreed) {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 4px 15px rgba(108, 92, 231, 0.25)";
                  }
                }}
              >
                📝 Register Now
              </button>
              <button
                className="action-btn"
                style={{
                  ...styles.secondaryBtn,
                  opacity: agreed ? 1 : 0.5,
                  cursor: agreed ? "pointer" : "not-allowed",
                }}
                onClick={() => agreed && navigate("/login")}
                disabled={!agreed}
                onMouseEnter={(e) => {
                  if (agreed) {
                    e.target.style.transform = "translateY(-3px)";
                    e.target.style.boxShadow = "0 8px 25px rgba(46, 213, 115, 0.4)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (agreed) {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 4px 15px rgba(0,0,0,0.05)";
                  }
                }}
              >
                🔑 Login
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RulesPage;

const styles = {
  page: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100dvh",
    width: "100vw",
    background: "linear-gradient(135deg, #0f0c29, #1a1a40, #24243e)",
    fontFamily: "'Segoe UI', 'Inter', system-ui, sans-serif",
    padding: 0,
    margin: 0,
    position: "relative",
    overflow: "hidden",
  },
  bgCircle1: {
    position: "absolute",
    width: "350px",
    height: "350px",
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(108,92,231,0.25) 0%, transparent 70%)",
    top: "-80px",
    right: "-60px",
    pointerEvents: "none",
  },
  bgCircle2: {
    position: "absolute",
    width: "280px",
    height: "280px",
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(46,213,115,0.2) 0%, transparent 70%)",
    bottom: "-70px",
    left: "-50px",
    pointerEvents: "none",
  },
  card: {
    width: "100%",
    height: "100dvh",
    backgroundColor: "rgba(255,255,255,0.97)",
    borderRadius: 0,
    padding: "30px 36px 20px",
    boxShadow: "none",
    textAlign: "center",
    position: "relative",
    zIndex: 1,
    backdropFilter: "blur(10px)",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  },
  // introBox is now completely transparent and only serves as a container
  // We removed it from the JSX and put its children directly in .responsive-header,
  // so this style is no longer needed. We keep it only for reference – it’s not used.
  introBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    backgroundColor: "transparent",
    padding: 0,
    borderRadius: 0,
    flexShrink: 0,
  },
  mainTitle: {
    fontSize: "45px",
    fontWeight: "800",
    color: "#1d5290",
    margin: "0 0 12px 0",
    lineHeight: "1.3",
  },
  subTitle: {
    fontSize: "28px",
    color: "#2d2d44",
    margin: "0 0 4px 0",
    lineHeight: "1.5",
    fontWeight: "500",
  },
  highlightText: {
    fontSize: "28px",
    fontWeight: "800",
    color: "#6c5ce7",
  },
  dateBadge: {
    display: "inline-block",
    backgroundColor: "#eef2ff",
    padding: "10px 20px",
    borderRadius: "25px",
    border: "1px solid #dcdde1",
    color: "#2d3436",
    fontSize: "20px",
    margin: "12px 0 0 0",
  },
  descText: {
    fontSize: "20px",
    lineHeight: "1.6",
    color: "#4a4a6a",
    margin: "0 0 8px 0",
  },
  rulesTextBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    textAlign: "left",
    marginTop: "16px",
    flexShrink: 0,
  },
  section: {
    marginBottom: "8px",
  },
  sectionHeading: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1d5290",
    margin: "0 0 8px 0",
    borderBottom: "2px solid #6c5ce7",
    paddingBottom: "4px",
  },
  rulePoint: {
    fontSize: "16px",
    lineHeight: "1.6",
    color: "#333",
    margin: "4px 0",
    paddingLeft: "4px",
  },
  nstadBox: {
    marginTop: "24px",
    marginBottom: "12px",
    padding: "20px 28px",
    fontSize: "20px",
    fontWeight: "600",
    background: "linear-gradient(135deg, #f5f3ff, #e8e4ff)",
    borderRadius: "16px",
    border: "2px solid #6c5ce7",
    boxShadow: "0 6px 20px rgba(108, 92, 231, 0.2)",
    color: "#1a237e",
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
    flexShrink: 0,
  },
  pinEmoji: {
    fontSize: "32px",
    lineHeight: 1,
  },
  nstadBoxText: {
    flex: 1,
  },
  nstadBoxLink: {
    color: "#6c5ce7",
    fontWeight: 900,
    textDecoration: "underline",
    textUnderlineOffset: "4px",
    fontSize: "22px",
    letterSpacing: "0.5px",
    transition: "all 0.2s",
  },
  nstadLink: {
    color: "#6c5ce7",
    fontWeight: 600,
    textDecoration: "underline",
  },
  actionGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    flexShrink: 0,
    marginTop: "16px",
    paddingBottom: "4px",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "17px",
    color: "#333",
    fontWeight: "600",
    cursor: "pointer",
    justifyContent: "center",
  },
  checkbox: {
    width: "20px",
    height: "20px",
    cursor: "pointer",
    accentColor: "#6c5ce7",
  },
  primaryBtn: {
    fontSize: "16px",
    fontWeight: "700",
    borderRadius: "10px",
    border: "none",
    background: "linear-gradient(135deg, #6c5ce7, #5a4bd1)",
    color: "#fff",
    boxShadow: "0 4px 15px rgba(108, 92, 231, 0.25)",
    transition: "all 0.25s ease",
  },
  secondaryBtn: {
    fontSize: "16px",
    fontWeight: "700",
    borderRadius: "10px",
    border: "2px solid #e0dcee",
    background: "#fff",
    color: "#4a4a6a",
    boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
    transition: "all 0.25s ease",
  },
};
